export default __webpack_public_path__ + "static/media/gl_5.b773558b.png";